import React, { useRef } from 'react';
var VeltNotificationsToolUnreadIcon = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-tool-unread-icon", { ref: ref }, children));
};
export default VeltNotificationsToolUnreadIcon;
